import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  modal: {
    top: '8em',
    right: 0,
  },
}));
